@let items = (models$ | async) ?? [];

<lib-multiselect
  titleTranslationKey="monitoring.model"
  chosenTranslationKey="monitoring.models-chosen"
  [options]="items"
  [formControl]="controlEntity"
  [isSearchDisplayed]="true"
  [disabled]="disabled"
  (shouldLoadMoreOptions)="loadMore()"
/>
